import React, { useEffect, useState } from "react";
import {
  getBlock,
  getDistrict,
  getFY,
  getGPbyBlock,
  getPaymentTrack,
} from "../../api/User";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SearchIcon from "@mui/icons-material/Search";
import logo from "../../images/logo192.png";
import html2canvas from "html2canvas";
import loader from "../../images/ajax-loader.gif";

function PaymentProcess({ token, userDetail }) {
  const [showTable, setShowTable] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [districtData, setDistrictData] = useState([]);
  const [districtType, setDistrictType] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [blockData, setBlockData] = useState([]);
  const [blockType, setBlockType] = useState("");
  const [blockName, setBlockName] = useState("");
  const [GPData, setGPData] = useState([]);
  const [GPName, setGPName] = useState("");
  const [GPType, setGPType] = useState("");
  const [villageId, setVillageId] = useState("");
  const [FYData, setFYData] = useState([]);
  const [fy, setFY] = useState("");
  const [month, setMonth] = useState("");
  const role = userDetail?.role_id;
  const id = userDetail?.user_id;
  const [base64Logo, setBase64Logo] = useState("");
  const [visibleOptions, setVisibleOptions] = useState([]);
  const [temp3, setTemp3] = useState([]);
  const [isReadonly, setIsReadonly] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedValueName, setSelectedValueName] = useState("");
  const [loadingBlock, setLoadingBlock] = useState(false);
  const [loading, setLoading] = useState(false);
  const [ledger, setLedger] = useState([]);
  const [paymentTrack, setpaymentTrack] = useState();

  useEffect(() => {
    if (GPData.length === 1) {
      setGPType(GPData[0].VillageId);
    }
  }, [GPData]);
  
  useEffect(() => {
    const options = [];
    if (role === 6 || role === 7) {
      options.push("gp");
      setSelectedValue("gp");
      setSelectedValueName("Gram Panchayat");
      setIsReadonly(true);
    } else if (role === 8 || role === 9) {
      options.push("ps");
      setSelectedValue("ps");
      setSelectedValueName("Panchayat Samiti");
      setIsReadonly(true);
    } else if (role === 10 || role === 11) {
      options.push("zp");
      setSelectedValue("zp");
      setSelectedValueName("Zila Parishad");
      setIsReadonly(true);
    } else {
      options.push("sab", "gp", "ps", "zp");
      setSelectedValue("");
      setIsReadonly(false);
    }
    fetchData();
    setVisibleOptions(options);
  }, [role]);

  const fetchData = async () => {
    try {
      const res = await getFY(token);
      setFYData([{ FY: "2024-25" }]);
      // setFYData(res.user);
    } catch (error) {
      console.error("Error fetching FY data:", error);
    }
  };

  const fetchDistrictData = async () => {
    try {
      const res = await getDistrict(
        token,
        userDetail.role_id,
        userDetail.user_id
      );
      setDistrictData(res.data);

      if (
        res.data.length > 0 &&
        (role === 6 ||
          role === 7 ||
          role === 8 ||
          role === 9 ||
          role === 10 ||
          role === 11)
      ) {
        setDistrictType(res.data[0].district_code);
        setDistrictName(res.data[0].district_name);
        fetchBlockData(res.data[0].district_code);
        if(res.data.length > 1) {
          setIsReadonly(false)
        }
      }
    } catch (error) {
      console.error("Error fetching district data:", error);
    }
  };

  const fetchBlockData = async (districtCode) => {
    setLoadingBlock(true);
    const data = {
      role_id: userDetail.role_id,
      id: userDetail.user_id,
      district: districtCode,
    };

    try {
      const res = await getBlock(token, data);
      setBlockData(res.user);

      if (res.user.length > 0 && [6, 7, 8, 9, 10, 11].includes(role)) {
        setBlockType(res.user[0].block_code);
        setBlockName(res.user[0].block_name);
        setIsReadonly(true);

        fetchVillageData(res.user[0].block_code, data.district);
      }
    } catch (error) {
      console.error("Error fetching block data:", error);
    }
  };

  const fetchVillageData = async (blockcode, district_code) => {
    const data1 = {
      role_id: userDetail.role_id,
      id: userDetail.user_id,
      district_code: district_code,
      block_code: blockcode,
    };

    try {
      await getGPbyBlock(token, data1)
        .then((res) => {
          setGPData(res.data);
          // setVillageId(res.data[0].VillageId);
          setIsReadonly(true);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error fetching block data:", error);
    }
  };

  const handleEntityChange = async (e) => {
    const newValue = e?.target?.value || selectedValue;
    setSelectedValue(newValue);
    await fetchDistrictData();
  };

  useEffect(() => {
    if (selectedValue) {
      handleEntityChange();
    }
  }, [selectedValue]);

  const handleDistrictChange = async (e) => {
    setDistrictType(e.target.value);
    setDistrictName(e.target.options[e.target.selectedIndex].text);
    const data = {
      role_id: userDetail.role_id,
      id: userDetail.user_id,
      district: e.target.value,
    };

    try {
      await getBlock(token, data)
        .then((res) => {
          setBlockData(res.user);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const handleBlockChange = async (e) => {
    setBlockType(e.target.value);
    setBlockName(e.target.options[e.target.selectedIndex].text);

    const data = {
      role_id: userDetail.role_id,
      id: userDetail.user_id,
      district_code: districtType,
      block_code: e.target.value,
    };

    try {
      await getGPbyBlock(token, data)
        .then((res) => {
          setGPData(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleGPChange = async (e) => {
    const { value } = e.target;
    // const gp = value.split("+")
    // setGPName(gp[1]);
    setGPType(value);
    const data = {
      role_id: role,
      id: id,
      block_code: blockType,
      VillageId: value,
    };
    await fetchData();
    setFY("")
  };

  const handleFYChange = (event) => {
    setFY(event.target.value);
    handlePaymentTrack(event.target.value);
  };

  const handlePaymentTrack = async (fy) => {
    const getSchemeByRole = (role_id) => {
      if (role_id === 6 || role_id === 7) return "gp";
      if (role_id === 8 || role_id === 9) return "ps";
      if (role_id === 10 || role_id === 11) return "zp";
      return "";
    };

    const data = {
      scheme: getSchemeByRole(userDetail.role_id),
      district_code: districtType,
      block_code: blockType,
      village_code: GPType,
    };

    try {
      setLoading(true);
      const res = await getPaymentTrack(token, data);
      setpaymentTrack(res.data);
      setShowTable(true);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch data");
      setpaymentTrack([]);
      setShowTable(false);
    } finally {
      setLoading(false);
    }
  };

  const filteredData = Array.isArray(paymentTrack)
    ? paymentTrack.filter((row) =>
        Object.values(row).some((value) =>
          value.toString().toLowerCase().includes(searchQuery.toLowerCase())
        )
      )
    : [];

  const handleSearch = (event) => {
    event.preventDefault();
    setShowTable(true);
  };

  useEffect(() => {
    const loadImage = async () => {
      const response = await fetch(logo);
      const blob = await response.blob();
      const reader = new FileReader();
      reader.onloadend = () => setBase64Logo(reader.result);
      reader.readAsDataURL(blob);
    };
    loadImage();
  }, []);

  const exportToPDF = () => {
    const table = document.getElementById("PaymentTrackTable");

    if (!table) {
      toast.error("Table not found.");
      return;
    }

    const tbody = table.querySelector("tbody");

    const dataRows = Array.from(tbody.children).filter(
      (row) =>
        row.querySelectorAll("td").length > 0 &&
        Array.from(row.querySelectorAll("td")).some(
          (cell) => cell.textContent.trim() !== ""
        )
    );

    if (dataRows.length === 0) {
      toast.error("The table is empty.");
      return;
    }

    html2canvas(table)
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF();

        pdf.addImage(base64Logo, "PNG", 7, 4, 20, 20);

        pdf.setFontSize(16);
        pdf.text(
          "Deducted Tax Details",
          pdf.internal.pageSize.getWidth() / 2,
          17,
          null,
          null,
          "center"
        );

        const imgWidth = pdf.internal.pageSize.getWidth() - 16;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        pdf.addImage(imgData, "PNG", 8, 35, imgWidth, imgHeight);

        pdf.save("PaymentProcess.pdf");
        toast.success("PDF file has been generated successfully.");
      })
      .catch((error) => {
        console.error("Error exporting to PDF:", error);
        toast.error("An error occurred while exporting to PDF.");
      });
  };

  const exportToExcel = () => {
    const table = document.getElementById("PaymentTrackTable");

    if (!table) {
      toast.error("Table not found.");
      return;
    }

    const tbody = table.querySelector("tbody");

    const dataRows = Array.from(tbody.children).filter(
      (row) =>
        row.querySelectorAll("td").length > 0 &&
        Array.from(row.querySelectorAll("td")).some(
          (cell) => cell.textContent.trim() !== ""
        )
    );

    if (dataRows.length === 0) {
      toast.error("The table is empty.");
      return;
    }

    try {
      const wb = XLSX.utils.table_to_book(table, { sheet: "Sheet1" });
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([wbout], { type: "application/octet-stream" });
      saveAs(blob, "PaymentProcess.xlsx");

      toast.success("Excel file has been generated successfully.");
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      toast.error("An error occurred while exporting to Excel.");
    }
  };

  return (
    <div>
      <div id="loading-coupon" style={{ display: loading ? "block" : "none" }}>
        <img id="loading-image" src={loader} alt="Loading..." />
      </div>
      <div className="container-fluid col px-2 px-md-4">
        <div className="my-5 col-12 d-flex justify-content-between align-items-center">
          <h5>
            <strong>Payment Tracking</strong>
          </h5>
        </div>
        <form className="filter" id="myform" onSubmit={handleSearch}>
          <div className="row mb-4">
            <div className="col-4">
              <label htmlFor="type" className="form-label">
                Entity {<span style={{ color: "red" }}>*</span>}{" "}
              </label>
              {role == 6 || role == 7 || role == 8 ? (
                <input
                  name="type"
                  id="type"
                  className="form-control"
                  value={selectedValueName}
                  onChange={handleEntityChange}
                  disabled={isReadonly}
                  required
                />
              ) : (
                <select
                  name="type"
                  id="type"
                  className="type form-select"
                  value={selectedValue}
                  onChange={handleEntityChange}
                  disabled={isReadonly}
                >
                  <option value="" disabled>
                    Select Type
                  </option>
                  {visibleOptions.includes("sab") && (
                    <option value="sab">All</option>
                  )}
                  {visibleOptions.includes("gp") && (
                    <option value="gp">Gram Panchayat</option>
                  )}
                  {visibleOptions.includes("ps") && (
                    <option value="ps">Panchayat Samiti</option>
                  )}
                  {visibleOptions.includes("zp") && (
                    <option value="zp">Zila Parishad</option>
                  )}
                  {visibleOptions.includes("zp") && (
                    <option value="zp">District</option>
                  )}
                </select>
              )}
            </div>
          </div>
          <div className="row d-flex">
            <div className style={{ width: "25%" }}>
              <label className="form-label" style={{ fontSize: "18px" }}>
                District {<span style={{ color: "red" }}>*</span>}
              </label>
              {districtData.length == 1 ? (
                <input
                  name="district"
                  className="form-control"
                  value={districtName}
                  onChange={handleDistrictChange}
                  disabled={isReadonly}
                  required
                />
              ) : (
                <select
                  name="district"
                  className="common-input form-select"
                  value={districtType}
                  onChange={handleDistrictChange}
                  //disabled={isReadonly}
                  required
                >
                  <option value="" disabled>
                    Select District
                  </option>
                  {(role === 1 ||
                    role === 2 ||
                    role === 3 ||
                    role === 4 ||
                    role === 19 ||
                    role === 20 ||
                    role === 22) && <option value="all">All</option>}

                 
{districtData
  .filter((district, index, self) => 
    index === self.findIndex(d => d.district_code === district.district_code)
  )
  .map((district, index) => (
    <option key={index} value={district.district_code}>
      {district.district_name}
    </option>
  ))}
                </select>
              )}
            </div>
            {(role == 8 || role == 9 || role == 6 || role == 7) && (
              <div className style={{ width: "25%" }}>
                <label className="form-label" style={{ fontSize: "17px" }}>
                  Block {<span style={{ color: "red" }}>*</span>}
                </label>
                {blockData?.length == 1 ? (
                  <input
                    name="block"
                    className="form-control"
                    type="text"
                    value={blockData[0]?.block_name}
                    disabled={isReadonly}
                  />
                ) : (
                  <select
                    name="block"
                    className="common-input form-select"
                    value={blockType}
                    onChange={handleBlockChange}
                    required
                  >
                    <option value="" disabled>
                      {" "}
                      Select Block
                    </option>

                    {blockData?.map((block, index) => (
                      <option key={index} value={block.block_code}>
                        {block.block_name}
                      </option>
                    ))}
                  </select>
                )}
              </div>
            )}
            {(role == 6 || role == 7) && (
               <div style={{ width: "25%", marginRight: "0.2%" }}>
               <label className="form-label">
                 Gram Panchayat {<span style={{ color: "red" }}>*</span>}
               </label>
               {GPData?.length === 1 ? (
                 <input
                   name="GP"
                   className="form-control"
                   type="text"
                   value={GPData[0]?.VillageName || ""}
                   disabled={isReadonly}
                 />
               )  : (
                  <select
                    name="gp"
                    className="common-input form-select"
                    value={GPType}
                    onChange={handleGPChange}
                    required
                  >
                    <option value="" disabled>
                      Select Gram Panchayat
                    </option>
                    {GPData?.map((gp, index) => (
                      <option
                        key={index}
                        // value={`${gp.VillageId}+${gp.VillageName}`}
                        value={gp.VillageId}
                      >
                        {gp.VillageName}
                      </option>
                    ))}
                  </select>
                )}
              </div>
            )}
            <div
              style={{
                width: "20%",
              }}
            >
              <label className="form-label" style={{ fontSize: "17px" }}>
                Financial Year {<span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="Year"
                className="common-input form-select"
                value={fy}
                onChange={handleFYChange}
                required
              >
                <option value="" disabled>
                  Select Financial Year
                </option>
                {FYData?.map((fy, index) => (
                  <option key={index} value={fy.FY}>
                    {fy.FY}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </form>
        <div className="row d-flex -contentjustify-between mt-5">
          <div className="col-md-5">
            <div style={{ width: "96%" }}>
              <div className="input-group ">
                <span className="input-group-text" id="basic-addon1">
                  <SearchIcon />
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Type here to search..."
                  aria-label="Type here to search..."
                  aria-describedby="basic-addon1"
                  id="searchInput"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="col">
            <div className="row" style={{ width: "100%" }}>
              <div style={{ width: "36%" }}>
                <button
                  onClick={exportToPDF}
                  type="button"
                  className="btn"
                  style={{ width: "100%", marginLeft: "-10%" }}
                >
                  Export to PDF
                </button>
              </div>
              <div style={{ width: "35%" }}>
                <button
                  onClick={exportToExcel}
                  type="button"
                  className="btn"
                  style={{ width: "100%", marginLeft: "-10%" }}
                >
                  Export to Excel
                </button>
              </div>
            </div>
          </div>
        </div>

        <div style={{ overflowX: "auto" }} className="my-5">
          <>
            <table
              id="PaymentTrackTable"
              className="table table-bordered"
              aria-label="simple table"
            >
              <thead>
                <tr style={{ fontSize: "16px" }}>
                  <th
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                      width: "2%",
                    }}
                  >
                    Sr.No.
                  </th>
                  <th
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                      width: "5%",
                    }}
                  >
                    District Code
                  </th>
                  <th
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                      width: "20%",
                    }}
                  >
                    District Name
                  </th>
                  <th
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                      width: "8%",
                    }}
                  >
                    Block Code
                  </th>
                  <th
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                      width: "8%",
                    }}
                  >
                    Block Name
                  </th>
                  <th
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                      width: "4%",
                    }}
                  >
                    LGD Code
                  </th>

                  <th
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                      width: "6%",
                    }}
                  >
                    Panchayat Name
                  </th>
                  <th
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                      width: "6%",
                    }}
                  >
                    Date
                  </th>
                  <th
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                      width: "6%",
                    }}
                  >
                    Vendor Name
                  </th>
                  <th
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                      width: "6%",
                    }}
                  >
                    Build Amount
                  </th>
                  <th
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                      width: "6%",
                    }}
                  >
                    Payable Amount
                  </th>
                  <th
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                      width: "6%",
                    }}
                  >
                    Narration
                  </th>
                  <th
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                      width: "6%",
                    }}
                  >
                    Limit Type
                  </th>
                  <th
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                      width: "6%",
                    }}
                  >
                    Bank Ref ID
                  </th>
                  <th
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                      width: "6%",
                    }}
                  >
                    UTR No.
                  </th>
                  <th
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                      width: "6%",
                    }}
                  >
                    Scheme
                  </th>
                  <th
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                      width: "6%",
                    }}
                  >
                    Overall Status
                  </th>
                </tr>
              </thead>
              {showTable ? (
                <tbody>
                  {filteredData.length === 0 ? (
                    <tr style={{ fontSize: "16px", color: "grey" }}>
                      <td colSpan="14" style={{ textAlign: "center" }}>
                        No data available
                      </td>
                    </tr>
                  ) : (
                    filteredData.map((row, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{row.district_code}</td>
                          <td>{row.district_name}</td>
                          <td>{row.block_code}</td>
                          <td>{row.block_name}</td>
                          <td>{row.lgd_code}</td>
                          <td>{row.panchayat_name}</td>
                          <td>{row.date?.replace("T", " ").replace(".000Z", "")}</td>

                          <td>{row.vendor_name}</td>
                          <td>{row.build_amount}</td>
                          <td>{row.transaction_amount}</td>
                          <td>{row.narration}</td>
                          <td>{row.limit_type}</td>
                          <td>{row.bank_ref_id}</td>
                          <td>{row.utr_no}</td>
                          <td>{row.scheme}</td>
                          <td>{row.overall_status}</td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              ) : (
                <tbody>
                  <tr style={{ fontSize: "16px", color: "grey" }}>
                    <td colSpan="8" style={{ textAlign: "center" }}>
                      No data available
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
          </>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}

export default PaymentProcess;
